export const engagementCampaignsCampaignsWithCarouselSlides =
  "/engagement/campaigns/campaigns_with_carousel_slides";
